export var EVENTS = {
	DOCUMENT_UPLOADED: 'DOCUMENT_UPLOADED'
};